// Module: brokerDisplay.js
// Purpose: Single lookup for broker id -> display label + badge tone (#10505 A6, P5).
//          No existing frontend broker display/icon registry was found (grepped
//          BrokerPlatforms/brokerDisplay/BROKER_LOGOS/brokerLabel — those are route
//          names or per-component fallback lists, not a shared lookup), so this is
//          the ONE new map. Reuse this instead of adding another broker if-ladder.

// -->  Registry — keyed by the broker id stored on rows (feed.broker, order.broker, ...)
const BROKER_DISPLAY = {
  flattrade: { label: 'Flattrade', tone: 'profit' },
  icici_direct: { label: 'ICICI Direct', tone: 'info' },
};

const DEFAULT_DISPLAY = { label: 'Default', tone: 'neutral' };

// -->  Lookup helper — unknown/missing broker id falls back to its raw value (or
//      "Default" when absent) with the neutral tone, never throws.
export const getBrokerDisplay = (brokerId) => {
  if (!brokerId) return DEFAULT_DISPLAY;
  return BROKER_DISPLAY[brokerId] || { label: brokerId, tone: 'neutral' };
};

export default BROKER_DISPLAY;
